import './App.css';
import { BrowserRouter } from 'react-router-dom';
import NavBar from './components/NavBar/NavBar';
import { RootRouter } from './routes/RootRouter';
import { Bounce, ToastContainer } from 'react-toastify';

function App() {
  return (
    <>
      <BrowserRouter>
        <NavBar />
        <RootRouter />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar
          closeOnClick
          pauseOnHover
          draggable
          transition={Bounce}
        />
      </BrowserRouter>
    </>
  );
}

export default App;
